import React from 'react';
import Footer from './Reusable/Footer'
import './App.css';
import './index.css';
import Navbar from './Reusable/Navbar';
import Home from './Reusable/Home';
import Aboutme from './Reusable/Aboutme';
import Services from './Reusable/Services';


function App() {
  //TODO:form funtionality,timeline
  return (
    <div>
      <Navbar/>
      <Home/>
      <Aboutme/>
      <Services/>
      <Footer/>
    </div>
  );
}


export default App;
